import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: 15,
    minWidth: theme.spacing(45),
  },
  table: {
    maxWidth: 400,
  },
  tableContainer: {
    maxHeight: 490,
    overflowY: 'auto',
  },
}));

export default useStyles;
